import { useLocation } from "react-router-dom";

const layoutPaths = [
  "/allGame",
  "/home",
  "/profile",
  "/disclaimer",
  "/chart",
  "/chart/result_data",
  "/match",
  "/leaderboard",
  "/support",
  "/share",
  "/wallet",
  "/transaction_history",
  "/game/live_game",
];

export const useShouldUseLayout = () => {
  const location = useLocation();
  return layoutPaths.some((path) => location.pathname.startsWith(path));
};
